module.exports = __webpack_public_path__ + "static/media/healthy.fab91511.svg";